import { Controller } from "stimulus";

// Mirrors the model rule (SHP-19163): a unit price only exists together with
// an additional procedure. With the procedure select on "— None —" the price
// field is cleared and disabled; picking E01/E02 re-enables it.
export default class extends Controller {
  static targets = ["procedure", "price"];

  connect() {
    this.sync();
  }

  sync() {
    const hasProcedure = this.procedureTarget.value !== "";

    if (!hasProcedure) this.priceTarget.value = "";
    this.priceTarget.disabled = !hasProcedure;
  }
}
